import type { ReactNode } from 'react';

import { ThirdPartyReview } from '../model';

/**
 * Derives the accessible label text for a third-party review link from the
 * caller-provided custom label (if it is plain text) or from the review's
 * count. Falls back to "Read reviews" when no count is available so screen
 * readers never announce a raw/null value.
 */
export function getReviewLinkLabel(
  linkLabel: ReactNode | string | number | undefined,
  review: ThirdPartyReview
): string {
  if (typeof linkLabel === 'string' || typeof linkLabel === 'number') {
    return String(linkLabel);
  }
  return review.reviewCount != null ? `${review.reviewCount.toLocaleString()} Reviews` : 'Read reviews';
}
